export const pineDarker = '#0D3A32';
export const pineDark = '#016060';
export const pine = '#1F8573';
export const pineLight = '#2AB69D';
export const pineLighter = '#6FBDA1';
export const pineLightest = '#EEFBF9';
export const kimberlyDarker = '#403758';
export const kimberlyDark = '#4F456E';
export const kimberly = '#7C6AB1';
export const kimberlyLight = '#A49BC0';
export const kimberlyLighter = '#CCC7DC';
export const kimberlyLightest = '#F1EFF5';
export const blueDarker = '#121B36';
export const blueDark = '#1F2C4F';
export const blue = '#384B7D';
export const blueLight = '#4462B1';
export const blueLighter = '#8496C7';
export const blueLightest = '#DCE1EF';
